// Microsoft Clarity — heatmaps + session recordings, free + privacy-friendly.
// Same gating as GA4 : only loads after `cookie_consent_analytics === 'true'`.
//
// To activate:
//   1. Sign up at https://clarity.microsoft.com (free)
//   2. Create a project for insidepanama.com → copy the project ID
//   3. Set VITE_CLARITY_ID in Netlify → Environment variables
//   4. Redeploy. Clarity loads automatically when users accept analytics.

import { ANALYTICS_CONSENT_KEY } from '@/i18n';

const CLARITY_ID = import.meta.env.VITE_CLARITY_ID;
let initialized = false;

function hasConsent() {
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem(ANALYTICS_CONSENT_KEY) === 'true';
  } catch {
    return false;
  }
}

export function initClarity() {
  if (initialized) return;
  if (!CLARITY_ID) return;
  if (!hasConsent()) return;
  if (typeof window === 'undefined') return;

  // Standard Clarity init snippet — adapted for ESM.
  ;(function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_ID);

  initialized = true;
}

// Retrait du consentement — même logique que teardownAnalytics : sans ça, le
// session replay continuait d'enregistrer après un refus, jusqu'au reload.
export function teardownClarity() {
  if (typeof window === 'undefined') return;
  try {
    window.clarity?.('stop');
  } catch {
    /* Clarity absent — rien à arrêter */
  }
  initialized = false;
}
